import { render, staticRenderFns } from "./TopUpMethod.vue?vue&type=template&id=e3afc990"
import script from "./TopUpMethod.vue?vue&type=script&lang=js"
export * from "./TopUpMethod.vue?vue&type=script&lang=js"
import style0 from "./TopUpMethod.vue?vue&type=style&index=0&id=e3afc990&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports